import { useTranslation } from "react-i18next";

import { useProductRecommendations } from "../../apis";
import { RecommendationStrip } from "../../components";

interface GoesWithStripProps {
  /** Product UUID or variant shortId. */
  productId: string;
}

const GoesWithStrip = ({ productId }: GoesWithStripProps) => {
  const { t } = useTranslation();

  const { recommendations, isLoading } = useProductRecommendations(productId);

  return (
    <RecommendationStrip
      recommendations={recommendations}
      isLoading={isLoading}
      note={t(
        "Admin QA preview — the engine's output for this product. Only visible, in-stock products."
      )}
      emptyText={t(
        "The engine has no complementary products for this one yet."
      )}
    />
  );
};

export default GoesWithStrip;
